import { horsesList, updatesList } from './apiActions';
import moment from 'moment';

export const refreshIfSaleDay = (store, saleStart, saleEnd) => {

  // if (moment().isBetween(moment(saleStart, 'MM-DD-YYYY'), moment(saleEnd, 'MM-DD-YYYY'), 'days', '[]')) {
  if (true) {
    setInterval(() => {
      store.dispatch(horsesList());
      store.dispatch(updatesList());
    }, 5 * 60 * 1000);
  }
}

